import { closeModal, openModal } from '@/modules/global-modal/globalModalSlice'
import { GlobalModalKey } from '@/modules/global-modal/types'

export const showGlobalLoading = () =>
  openModal({ key: GlobalModalKey.Loading })

export const hideGlobalLoading = () =>
  closeModal({ key: GlobalModalKey.Loading })
